'use strict';
import React from 'react';
import flux from 'utils/flux';

var ConfirmModal = React.createClass({
    displayName: 'ConfirmModal',
    propTypes: {
        data: React.PropTypes.object
    },
    render() {

        return (
            <div>
                <h4>{this.props.data.title}</h4>
                <ul>
                    {this.props.data.basketNames.map((basketName) => <li>{basketName}</li>)}
                </ul>
                <button onClick={this.props.data.onConfirm} className="btn btn-primary">{flux.t('confirm')}</button>
                <button onClick={flux.getActions('modals').closeModals} className="btn btn-secondary">{flux.t('cancel')}</button>
            </div>
        );
    }
});

module.exports = ConfirmModal;



// WEBPACK FOOTER //
// ./app/components/modals/confirmModal.jsx